/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutLoyaltyCouponController', function ($scope, $q, $element, ControlService) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'LoyaltyCoupon';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.SelectedCoupon = '';
            $scope.Control.Loading = false;

            $scope.Control.ValidationCode = '';
            $scope.Control.ShowValidationCodeForm = false;
            $scope.Control.ShowErrorMessage = false;
            $scope.Control.ErrorMessage = '';

            $scope.Control.SelectCouponFailed = false;
            $scope.Control.SelectCouponFailedText = '';
            $scope.Control.HasSelectedCoupon = false;
            $scope.Control.CanSubmit = false;
            $scope.Control.CanCancel = false;

            var maxAttempts = -1, attempts = 0;

            $scope.Control.cancelCoupon = function () {
                $scope.Control.setValidationCode();

                var couponCode = $scope.Control.getCouponCode();
                ControlService.invokeCheckout($scope, $element, 'CancelCoupon', couponCode).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    if (!result) {
                        toastr.error('Something went wrong : Clear coupon failed');
                    }

                    $scope.Control.reload();
                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });

                    $scope.Control.Loading = false;
                }, function (error) {
                    toastr.error('Something went wrong : Clear coupon failed');

                    $scope.Control.reload();
                    $scope.Order.Wrapper.reload().then(function () {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });

                    $scope.Control.Loading = false;
                });
            };

            $scope.Control.applyCoupon = function () {
                $scope.Control.setValidationCode();

                var couponCode = $scope.Control.getCouponCode();
                ControlService.invokeCheckout($scope, $element, 'ApplyCoupon', couponCode).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    if (result.StatusCode === 200) {
                        $scope.Control.reload();

                        $scope.Order.Wrapper.reload().then(function () {
                            $scope.Control.Loading = false;
                        }, function (error) {
                            $scope.Control.Loading = false;
                            throw error;
                        });

                    } else {
                        toastr.error('Something went wrong : Code could apply coupon');
                    }

                    $scope.Control.Loading = false;
                }, function (error) {
                    toastr.error('Something went wrong : Code could apply coupon');
                    $scope.Control.Loading = false;
                });
            };

            $scope.Control.submitCode = function () {
                if (!$scope.Control.ValidationCode || $scope.Control.ValidationCode.trim() === '' || !$scope.Control.CanSubmit) {
                    $scope.Control.ValidationCodeRequired = true;
                    return;
                }

                $scope.Control.ValidationCodeRequired = false;
                $scope.Control.Loading = true;
                ControlService.invokeCheckout($scope, $element, 'ValidateCode', $scope.Control.ValidationCode).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    if (result.StatusCode === 200) {
                        attempts = 0;
                        $scope.Control.applyCoupon();
                    } else {
                        if ($scope.Control.validateAttempt()) {
                            $scope.Control.ShowErrorMessage = true;
                            $scope.Control.ErrorMessage = result.ResponseMessage;
                        } else {
                            toastr.error('You have exceeded the maximum number of Tries (' + maxAttempts + '). Please try again.');
                            $scope.Control.resetForm();
                        }

                        $scope.Control.Loading = false;
                    }

                }, function (error) {
                    if ($scope.Control.validateAttempt()) {
                        toastr.error('Something went wrong : Code could not be validated');
                    } else {
                        toastr.error('You have exceeded the maximum number of Tries (' + maxAttempts + '). Please try again.');
                        $scope.Control.resetForm();
                    }

                    $scope.Control.Loading = false;
                });

            };

            $scope.Control.selectCoupon = function () {
                if ($scope.Control.SelectedCoupon === '' || $scope.Control.SelectedCoupon === undefined) {
                    return;
                }
                $scope.Control.setCouponCode($scope.Control.SelectedCoupon);
                $scope.Control.applyCoupon();
// todo !!!! add check???
/*
                $scope.Control.Loading = true;
                ControlService.invokeCheckout($scope, $element, 'SelectLoyaltyCoupon', $scope.Control.SelectedCoupon).then(function (response) {
                    var result = jQuery.parseJSON(response);
                    if (result.StatusCode === 200) {
                        $scope.Control.setCouponCode($scope.Control.SelectedCoupon);
                        $scope.Control.resetValidationForm();
                    } else {
                        $scope.Control.resetForm();
                        $scope.Control.SelectCouponFailed = true;
                        $scope.Control.SelectCouponFailedText = result.ErrorSendText;
                    }
                    $scope.Control.Loading = false;
                }, function (error) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.resetForm();
                    $scope.Control.SelectCouponFailed = true;
                    $scope.Control.SelectCouponFailedText = result.ErrorSendText;

                    $scope.Control.Loading = false;
                });
*/
            };

            $scope.Control.validateAttempt = function () {
                if (attempts > maxAttempts) {
                    attempts = 0;
                    return false;
                }
                attempts++;
                return true;
            };

            $scope.Control.resetValidationForm = function () {
                $scope.Control.setCouponCode($scope.Control.SelectedCoupon);
                $scope.Control.removeValidationCode();
                $scope.Control.ShowValidationCodeForm = true;
                $scope.Control.ValidationCode = $scope.Model.Data.LoyaltyCoupons.ValidationCodeText;
                $scope.Control.CanSubmit = true;
                $scope.Control.ValidationCodeRequired = false;
            };

            $scope.Control.resetForm = function () {
                $scope.Control.HasSelectedCoupon = false;
                $scope.Control.SelectCouponFailed = false;
                $scope.Control.SelectedCoupon = '';
                $scope.Control.removeCouponCode();
                $scope.Control.removeValidationCode();
                $scope.Control.CanSubmit = false;
                $scope.Control.CanCancel = false;
                $scope.Control.ValidationCodeRequired = false;
                $scope.Control.ShowValidationCodeForm = false;
            };

            /* Store coupon code for cancel after model change */
            $scope.Control.getCouponCode = function () {
                return sessionStorage.getItem('SelectedCoupon');
            };

            $scope.Control.setCouponCode = function (couponCode) {
                if (couponCode) {
                    sessionStorage.setItem('SelectedCoupon', couponCode);
                }
            };

            $scope.Control.removeCouponCode = function () {
                sessionStorage.removeItem('SelectedCoupon');
            };

            /* Store validation code for display */
            $scope.Control.getValidationCode = function () {
                return sessionStorage.getItem('ValidationCode');
            };

            $scope.Control.setValidationCode = function () {
                if ($scope.Control.ValidationCode) {
                    sessionStorage.setItem('ValidationCode', $scope.Control.ValidationCode);
                }
            };

            $scope.Control.removeValidationCode = function () {
                sessionStorage.removeItem('ValidationCode');
            };


            $scope.Control.reload = function () {
                ControlService.getCheckoutData("GetLoyaltyCouponData", $scope, $element).then(function (response) {
                    $scope.Model = {};
                    angular.extend($scope.Model, response);

                    if ($scope.Model.Data.LoyaltyCoupons === null)
                        return;

                    if ($scope.Model.Data.LoyaltyCoupons.HasSelectedCoupon) {
                        $scope.Control.HasSelectedCoupon = true;
                        $scope.Control.ShowValidationCodeForm = true;

                        var code = _.first(_.filter($scope.Model.Data.LoyaltyCoupons.LoyaltyCoupons, function (x) { return x.IsSelected; })).Code;

                        $scope.Control.SelectedCoupon = code ? code : '';
                        if ($scope.Control.getCouponCode() !== $scope.Control.SelectedCoupon && $scope.Control.SelectedCoupon !== '' && $scope.Control.SelectedCoupon !== undefined) {
                            $scope.Control.setCouponCode($scope.Control.SelectedCoupon);
                        }
                        $scope.Control.ValidationCode = $scope.Control.getValidationCode();
                    } else {
                        $scope.Control.resetForm();
                    }

                    if ($scope.Control.ValidationCode) {
                        $scope.Control.ValidationCode = $scope.Model.Data.LoyaltyCoupons.ValidationCodeText;
                    }

                    maxAttempts = $scope.Model.Data.LoyaltyCoupons.MaxAttempts;

                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $scope.Control.reload();

        });
})();